import _ from "lodash";
import React, { useEffect, useState } from "react";
import AppGraphQl from "js/graphql/resolvers/segmento.resolver";
import { GQLParamBuilder } from "../../../../../helpers";

const FEEDBACK_MSGS = {
  SEGMENTO_NOT_FOUND: "No se encontraron segmentos para el idPrograma"
};

//cache-first, cache-only, cache-and-network, network-only, no-cache, standby
const fetchData = async (client, idPrograma, setFormParams) => {
  const formatData = true;

  try {
    const opBuilder = new GQLParamBuilder(client);

    const { getSegmentosWithTemplate } = AppGraphQl.queries;

    opBuilder.setOperation(getSegmentosWithTemplate);

    const variables = {
      segmentoLike: {
        idPrograma: parseInt(idPrograma)
      },
      segmentoOrder: {
        order: "asc",
        orderBy: "idSegmento"
      },
      page: {
        page: 1,
        rowsPerPage: 1
      }
    };

    opBuilder.setVariables({ ...variables });

    const result = await opBuilder.exec();

    if (!result.data && !result.data.getSegmentos) {
      throw new Error(FEEDBACK_MSGS.SEGMENTO_NOT_FOUND);
    }

    let {
      data: { getSegmentos: segmentos }
    } = result;

    if (formatData) {
      segmentos = segmentos.map(segmento => {
        let {
          idSegmento,
          nombre,
          template: { template }
        } = segmento;
        template = JSON.parse(template);
        let {
          templateDev: {
            template: {
              header: {
                menu: {
                  navbar: { items }
                }
              }
            }
          }
        } = template;
        return {
          value: idSegmento,
          label: nombre,
          checked: false,
          children: items.map(item => ({
            value: item.link,
            label: item.texto,
            checked: false
          }))
        };
      });
    }

    return segmentos;
  } catch (error) {
    setFormParams(prev => ({
      ...prev,
      errors: error.message
    }));

    return null;
  }
};

export const useGetSegmentos = ({ client, idPrograma, setFormParams }) => {
  const [segmentos, setSegmentos] = useState([]);

  useEffect(
    () => {
      const getSegmentos = async () => {
        if (!_.isNil(idPrograma)) {
          const segmentosFound = await fetchData(
            client,
            idPrograma,
            setFormParams
          );
          if (!_.isNil(segmentosFound)) {
            setSegmentos(segmentosFound);
          }
        }
      };
      getSegmentos();
    },
    [idPrograma]
  );

  return [...segmentos];
};
